import { Injectable, inject } from '@angular/core';
import { BaseAppSyncService } from '../base-app-sync.service';
import { Observable } from 'rxjs';
import { getSapOutage } from '../../graphql/sap/get-sap-outage';
import { syncSapOutagesForFacility } from '../../graphql/facilities/sync-sap-outages-for-facility';
import { SapOutage } from '../../model/sap/sap-outage';
import { SapBuilderService } from '../builder/sap-builder.service';
import { OutageGroup } from '../../model/sap/outage-group';
import { getOutageGroups } from '../../graphql/sap/get-outage-groups';

@Injectable({
  providedIn: 'root',
})
export class SapApiService extends BaseAppSyncService {
  protected _sapBuilderService = inject(SapBuilderService);

  syncSapOutagesForFacility(floc: string): Observable<boolean> {
    return this.mutate(
      syncSapOutagesForFacility,
      { floc },
      (i: any) => i.value,
      'syncSapOutagesForFacility'
    );
  }

  getSapOutage(outageId: string): Observable<SapOutage> {
    return this.query(
      getSapOutage,
      { outageId },
      (item: any) => this._sapBuilderService.buildSapOutage(item),
      'getSapOutage'
    );
  }

  getOutageGroups(): Observable<OutageGroup[]> {
    return this.query(
      getOutageGroups,
      {},
      (i: any) =>
        i.map((i: any) => this._sapBuilderService.buildOutageGroup(i)),
      'getOutageGroups'
    );
  }
}
